import * as React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../redux';
import {Route, useNavigation} from '@react-navigation/native';
import {productDetailedSelector} from '../../../redux/selectors/products';
import {getDetailedProduct} from '../../../redux/actions/products';

function _ProductItemScreen({route}: {route: Route<string>}) {
  //@ts-ignore
  const id = route.params?.id;
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    dispatch(getDetailedProduct(id));
  }, [id]);

  const product = useSelector(productDetailedSelector());
  const navigation = useNavigation();
  React.useEffect(() => {
    if (!product) return;
    navigation.setOptions({title: product.name.trim() || 'Товар'});
  }, [product, navigation]);

  const productAcceptors = React.useMemo(() => product?.departments, [product, id]);

  if (!product || !productAcceptors) return <></>;
  return <View product={product} id={id} productAcceptors={productAcceptors} />;
}

export const ProductItemScreen = React.memo(_ProductItemScreen);
